import React from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MapTool } from "../tools";
import { useState } from "react";
import './info-popup.scss';
import { DataView } from 'primereact/dataview';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Tooltip } from "primereact/tooltip";
import { Chip } from "primereact/chip";
import { FilterMatchMode, FilterOperator } from "primereact/api";

export const InfoPopup = (props) => {
    const [expandedRows, setExpandedRows] = useState(null);
    const [expandedIdentifier, setExpandedIdentifier] = useState({});
    const [filters, setFilters] = useState({
        'properties.id': { value: null, matchMode: FilterMatchMode.EQUALS },
        title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const formatAllDates = (obj) => {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];             
                if (typeof value === 'string' && !isNaN(Date.parse(value))) {
                    const date = new Date(value);                 
                    if (!isNaN(date.getTime()) && isNaN(value)) {
                        obj[key] = formatDate(value);
                    }
                } else if (typeof value === 'object' && value !== null) {
                    formatAllDates(value);
                }
            }
        }
    };

    const detailBodyTemplate = (rowData) => {
        
        if (props.isGetInfoRowData) {
            return <Button
                icon={"pi pi-eye"}
                size="small"
                style={{ width: 40 }}
                onClick={() => {
                    if (props.getInfoRowDataFunc) {

                        props.getInfoRowDataFunc(rowData)
                    }
                }}
            />;
        }
        else {
            return <Button
                icon={"pi pi-eye"}
                size="small"
                style={{ width: 40 }}
                onClick={() => {

                    const mapTool = props.map?.current?.mapTool;

                    if (expandedRows && expandedRows[rowData.properties.id]) {
                        setExpandedRows(null);
                        mapTool.clearLayersByName(["info-layer"]);
                    }
                    else {
                        setExpandedRows(null);

                        let feature = MapTool.convertGeoJsonToFeature(rowData.geoJSON, mapTool.wktProjection, mapTool.mapProjection)


                        if (!mapTool.findLayer("info-layer")) {
                            const infoLayer = MapTool.createVectorLayer({
                                name: "info-layer",
                                source: MapTool.createVectorLayerSource({})
                            });
                            mapTool.addLayer(infoLayer);

                        }
                        mapTool.clearLayersByName(["info-layer"]);
                        feature.setStyle(mapTool.getInfoStyle(feature.getGeometry().getType(), props.infoColor));
                        const source = mapTool.getLayerSource("info-layer");
                        source.addFeature(feature);
                        mapTool.findLayer("info-layer").setZIndex(999999);


                        //açacak
                        if (!rowData.isFormExist) {
                            formatAllDates(rowData);
                            let _expandedRows = {};

                            _expandedRows[rowData.properties.id] = true;

                            setExpandedRows(_expandedRows);
                        }
                        else {
                            if (props.dynamicData) {


                                props.dynamicData(rowData);
                            }
                        }
                    }

                }}
            />;
        }
    };

    const itemTemplate = (item, index) => {

        let keys = Object.keys(item);

        return (
            <>
                <ScrollPanel style={{ width: '100%', height: '200px' }}>
                    {keys.map(x => {
                        return (
                            <div className="field grid">
                                <label className="col-12 mb-2 md:col-2 md:mb-0">{x.toLocaleUpperCase("tr-TR")}:</label>
                                <div className="col-12 md:col-10" style={{ display: 'flex', justifyContent: "end" }}>
                                    {item[x]}
                                </div>
                            </div>
                        )
                    })}
                </ScrollPanel>
            </>
        );
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((item, index) => {
            return itemTemplate(item, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    const rowExpansionTemplate = (data) => {
        let _data = [];
        _data.push(data.properties)
        return (
            <div className="p-3">
                <DataView value={_data} listTemplate={listTemplate} />
            </div>
        );
    };

    const toggleExpand = (id) => {
        setExpandedIdentifier(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const identifierColumnTemplate = (rowData) => {
        const identifiers = rowData.identifierColumns?.flatMap(obj => Object.entries(obj)) || [];

        const visibleIdentifiers = identifiers.slice(0, 2);
        const hiddenIdentifiers = identifiers.slice(2);

        return (
            <div className="flex flex-wrap gap-1">
                {visibleIdentifiers.map(([key, value], index) => (
                    <Chip
                        key={index}
                        label={`${key}: ${value}`}
                        className="text-xs px-1 py-0.5"
                        style={{ borderRadius: 0 }}
                    />
                ))}

                {hiddenIdentifiers.length > 0 && (
                    <>
                        {!expandedIdentifier[rowData.properties.id] ? (
                            <span
                                id={`more-${rowData.properties.id}`}
                                className="text-xs cursor-pointer text-blue-500"
                                onClick={() => toggleExpand(rowData.properties.id)}
                            >
                                +{hiddenIdentifiers.length} daha
                            </span>
                        ) : (
                            <>
                                {hiddenIdentifiers.map(([key, value], index) => (
                                    <Chip
                                        key={`hidden-${index}`}
                                        label={`${key}: ${value}`}
                                        className="text-xs px-1 py-0.5"
                                        style={{ borderRadius: 0 }}
                                    />
                                ))}
                                <span
                                    id={`hide-${rowData.properties.id}`}
                                    className="text-xs cursor-pointer text-blue-500"
                                    onClick={() => toggleExpand(rowData.properties.id)}
                                >
                                    Gizle
                                </span>
                            </>
                        )}
                    </>
                )}

                {!expandedIdentifier[rowData.properties.id] && hiddenIdentifiers.length > 0 && (
                    <Tooltip
                        target={`#more-${rowData.properties.id}`}
                        content={hiddenIdentifiers.map(([key, value]) => `${key}: ${value}`).join(', ')}
                        className="text-xs p-1"
                        style={{ maxWidth: "200px", whiteSpace: "normal", fontSize: "10px", padding: "2px 4px" }}
                    />
                )}
            </div>
        );
    };

    const filterOptions = [
        { label: 'Eşit', value: 'equals' },
        { label: 'Eşit değil', value: 'notEquals' },
        { label: 'İçeriyor', value: 'contains' },
        { label: 'İçermiyor', value: 'notContains' },
        { label: 'Şununla başla', value: 'startsWith' },
        { label: 'Şununla bitsin', value: 'endsWith' }
    ];

    const filterClearTemplate = (options) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback} label="Temizle" className="p-button-raised p-button-secondary p-button-sm" />;
    }

    const filterApplyTemplate = (options) => {
        return <Button type="button" icon="pi pi-check" onClick={options.filterApplyCallback} label="Uygula" className="p-button-raised p-button-success p-button-sm" />;
    }

    return (
        <>
            <Dialog
                headerClassName="info-popup-header"
                header="Bilgi Al"
                baseZIndex={99}
                visible={props.visible}
                onHide={() => { props.visibleFunc(); props.map.current.mapTool.clearLayersByName(["info-layer"]) }}
                style={{ width: '35vw', maxHeight: 560 }}
                modal={false}
                position="right">

                <DataTable
                    rowExpansionTemplate={rowExpansionTemplate}
                    value={props.infoData}
                    style={{ marginTop: 10 }}
                    size="small"
                    expandedRows={expandedRows}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    dataKey="properties.id"
                    showGridlines
                    paginator
                    emptyMessage="Kayıt Bulunamadı"
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    filterDisplay="menu"
                    globalFilterFields={['properties.id', 'title']}
                >
                    <Column
                        field="properties.id"
                        filter
                        showAddButton={false}
                        showFilterOperator={false}
                        filterPlaceholder="Id girin"
                        filterMatchMode="equals"
                        filterMatchModeOptions={filterOptions}
                        filterApply={filterApplyTemplate}
                        filterClear={filterClearTemplate}
                        header="Id"
                        className="text-xs font-semibold"
                    ></Column>

                    <Column
                        field="title"
                        filter
                        showAddButton={false}
                        showFilterOperator={false}
                        filterPlaceholder="Başlık girin"
                        filterMatchMode="contains"
                        filterMatchModeOptions={filterOptions}
                        filterApply={filterApplyTemplate}
                        filterClear={filterClearTemplate}
                        header="Başlık"
                        className="text-xs font-semibold"
                    ></Column>

                    {
                        props.checkIdentifierColumn &&
                        <Column
                            field="identifierColumns"
                            header="Tanımlayıcı Kolon"
                            body={identifierColumnTemplate}
                            headerStyle={{ width: '30%' }}
                            className="text-xs font-semibold"
                        ></Column>
                    }

                    <Column
                        field="detail"
                        body={detailBodyTemplate}
                        className="text-xs font-semibold"
                        headerStyle={{ width: '2rem' }}
                    ></Column>
                </DataTable>
            </Dialog>
        </>

    )
}

export default InfoPopup;